import React, { useState } from "react";
import Quantity from "./Main";

const DEFAULT_VALUE = {
  value: null,
  warning: null,
  message: 'Testing'
}

const Demo = () => {
  const [value, setValue] = useState({...DEFAULT_VALUE})

  return (
    <>
      <Quantity
        default_value={'1'}
        value={value}
        // show_message={true}
        onChange={(val) => setValue(val)}
      />
      <br/>
      <br/>
      {value && <ul>
        <li>Value: {value.value}</li>
      </ul>}
    </>
  )
}

export default Demo;
